import { SEARCH_CONFIG } from '../searchFlyoutConfig';

export const getDataTypes = (inv: keyof typeof SEARCH_CONFIG) => Object.keys(SEARCH_CONFIG[inv]);
